import React, { useCallback, useState } from 'react';
import { ATMButton } from 'shared-it-appmod-ui';
import { useFileContext } from 'src/contexts/file.context';
import { IFile } from 'src/models/file.model';

type IProps = {
  file?: Partial<IFile>;
};

const FileDownloader: React.FC<IProps> = ({ file }) => {
  const { actions } = useFileContext();
  const [loading, setLoading] = useState(false);

  const handleDownload = useCallback(async () => {
    if (file && file.fileName && file.docName) {
      setLoading(true);
      const result = await actions.downloadGET(file.fileName, file.docName);

      if (result.payload) {
        const link = document.createElement('a');
        link.setAttribute('href', result.payload.fileUrl);
        link.setAttribute('target', '_blank');
        link.setAttribute('download', file.docName || file.fileName);

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);
      }

      setLoading(false);
    }
  }, [file, actions, setLoading]);

  if (!file || (file && !file.fileName)) {
    return null;
  }

  return (
    <ATMButton
      icon="download"
      type="button"
      onClick={handleDownload}
      loading={loading}
      disabled={loading}
    />
  );
};

export default FileDownloader;
